import getComponent from '../utils/get-component'

export const Crate = getComponent('bg-white shadow-1')
export const PageCrate = getComponent(
  'bg-white mv3 pa3 center',
  {
    shadow: true,
    width: 7,
    backgroundColor: 'white'
  },
  ({ shadow, width, backgroundColor }) => ({
    className: `${shadow ? 'shadow-1' : ''} mw${width} bg-${backgroundColor}`
  })
)
export const CrateHeader = getComponent('bg-light-gray mid-gray pa3', 'header')
export const CrateContent = getComponent('pa3')
